<mat-card-header>
	<mat-card-title>
		{{title}}
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>

<div class="padding-vertical-md" *ngIf="!isLoading">
	<form [formGroup]="form" (ngSubmit)="submit()" #communicationEventsForm="ngForm">
		<div class="row">
			<div class="col-md-6">

				<div class="row">
					<div class="col-lg-12 inline">
						<mat-form-field class="w-100">
							<mat-label>
								Communication Type
							</mat-label>
							<mat-select formControlName="communicationEventPurposeType"
								(selectionChange)="communicationEventPurposeTypeChange($event)">
								<mat-option *ngFor="let communicationEventPurposeType of communicationEventPurposeTypes"
									[value]="communicationEventPurposeType">
									{{communicationEventPurposeType.TYPE}}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<help-text-btn class="align-help-text-btn" [helpTextId]="'CommunicationEvent_Type'"></help-text-btn>
					</div>
					<div class="col-lg-12 inline">
						<mat-form-field class="w-100">
							<mat-label>
								Communication Date
							</mat-label>
							<input matInput formControlName="communicationDate"
								[matDatepicker]="communicationDatePicker" (click)="communicationDatePicker.open()"
								startView="multi-year" [max]="communicationDateOptions.maxDate">
							<mat-datepicker-toggle matSuffix [for]="communicationDatePicker"></mat-datepicker-toggle>
							<mat-datepicker #communicationDatePicker startView="multi-year"
								[startAt]="communicationDateOptions.startAt"></mat-datepicker>
						</mat-form-field>
						<help-text-btn class="align-help-text-btn" [helpTextId]="'CommunicationEvent_Date'"></help-text-btn>
					</div>

					<div class="col-lg-12" *ngIf="form.get('communicationEventPurposeType')?.value">
						<mat-checkbox [color]="'primary'" class="checkbox-margin" formControlName="familyPresent">
							{{getPropertyPipe.transform(form.get('communicationEventPurposeType')?.value,
							'COMMUNICATION_EVENT_PURPOSE_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES.DESCRIPTION',
							false, true)}}
						</mat-checkbox>

					</div>
				</div>
			</div>

			<div class="col-lg-6 inline">
				<mat-form-field class="w-100">
					<mat-label>
						Comments
					</mat-label>
					<textarea matInput id="comments" name="comments" type="string" formControlName="comments"
						rows="4"></textarea>
					<mat-hint>Enter your comments here.</mat-hint>
				</mat-form-field>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'CommunicationEvent_Comments'"></help-text-btn>
			</div>


		</div>
	</form>

	<hr />

	<mat-card-actions>
		<confirm-popover *ngIf="!studentCommunicationEvents" class="margin-right-xs" [buttonType]="'string'"
			[color]="'primary'" [popoverMsg]="'Confirm New Communication Event'" [popoverConfirmText]="'Create'"
			[buttonTxt]="'Create'" [popoverConfirmColor]="'primary'" (onConfirm)="submit()"
			[disabled]="isSubmitting || form.invalid || (msg && msg.SUCCESS!)">
		</confirm-popover>
		<confirm-popover *ngIf="studentCommunicationEvents" class="margin-right-xs" [buttonType]="'string'"
			[color]="'primary'" [popoverMsg]="'Confirm Update Communication Event'" [popoverConfirmText]="'Update'"
			[buttonTxt]="'Update'" [popoverConfirmColor]="'primary'" (onConfirm)="submit()"
			[disabled]="isSubmitting  || form.invalid || (msg && msg.SUCCESS!)">
		</confirm-popover>

		<button type="button" color="warn" mat-raised-button (click)="cancel()"
			[disabled]="isSubmitting || (msg && msg.SUCCESS!)" class="margin-right-xs">
			Cancel
		</button>

		<button type="button" mat-icon-button *ngIf="isSubmitting">
			<mat-icon>
				<mat-spinner diameter="18"> </mat-spinner>
			</mat-icon>
		</button>

		<span>* Required fields</span>
		<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
	</mat-card-actions>
</div>